import { aboutData } from "./aboutData";
import { blogsData } from "./blogsData";
import { heroData } from "./heroData";
import { servicesData } from "./servicesData";
import { testimonialsData } from "./testimonialsData";
import { workshopsData } from "./workshopsData";

export const tempSiteData = {
  hero: heroData,
  services: servicesData,
  testimonials: testimonialsData,
  about: aboutData,
  blogs: blogsData,
  workshops: workshopsData,
};
